
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { getLocalizedTaxName, getEffectivePrice } from '@/utils/getters';
import QuantityInput from '@/components/shared/suites/QuantityInput.vue';

@Component<OrderDetails>({
	components: { QuantityInput }
})
export default class OrderDetails extends Vue {
	@Getter('isCateringRestaurant', { namespace: 'auth' }) private isCateringRestaurant!: boolean;
	@Getter('getRestaurant', { namespace: 'auth' }) private restaurant!: Restaurant;
	@Getter('isTaxInclusiveWithInfo', { namespace: 'auth' }) private isTaxInclusiveWithInfo!: boolean;
	@Prop({ type: Boolean, required: true }) private isEditing!: boolean;
	@Prop({ type: Boolean, required: true }) private loading!: boolean;
	@Prop({ type: Number, required: true }) private loadingIndex!: number;
	@Prop({ type: Object, required: true }) private order!: Order;
	@Prop({ type: Array, required: true }) private items!: OrderItem[];

	private get isCatering(): boolean {
		return this.isCateringRestaurant && this.order.type === 'generic-catering';
	}

	private get subtotal(): number | undefined {
		return this.order.data?.costs?.subtotal;
	}

	private get discount(): number | undefined {
		return this.order.data?.costs?.discount?.amount;
	}

	private get memberDiscount(): number | undefined {
		return this.order.data?.costs?.memberDiscount?.amount;
	}

	private get taxes(): number | undefined {
		return this.order.data?.costs?.taxes;
	}

	private get taxInfo(): OrderTaxInfo[] {
		return this.order.data?.costs?.taxInfo ?? [];
	}

	private get showSplitTaxes(): boolean {
		return this.restaurant.show_split_taxes;
	}

	private get serviceCharge(): number | undefined {
		return this.order.data?.costs?.serviceCharge?.amount;
	}

	private get deliveryCharge(): number | undefined {
		return this.order.data?.costs?.deliveryCharge?.amount;
	}

	private get voucher(): number | undefined {
		return this.order.data?.costs?.voucher?.amount;
	}

	private get credits(): number | undefined {
		return this.order.data?.costs?.credits?.amount;
	}

	private get total(): number | undefined {
		return this.order.data?.costs?.total;
	}

	private get tip(): number | undefined {
		return this.order.data?.costs?.tip?.amount;
	}

	private get totalWithTip(): number | undefined {
		return this.order.data?.costs?.totalWithTip;
	}

	private get isAnyLoading(): boolean {
		return this.loading || this.loadingIndex > -1;
	}

	private getEffectivePrice(item: OrderItem | Option): number | null {
		return getEffectivePrice(item);
	}

	/**
	 * Get the localized name of the tax if possible.
	 *
	 * @param {string} taxName
	 * @return {string}
	 */
	private getLocalizedTaxName(taxName: string): string {
		return getLocalizedTaxName(taxName, this.restaurant);
	}

	/**
	 * Get the option price depending of its quantity
	 *
	 * @param {Option} optionValue
	 * @param {number} itemQuantity
	 * @param {number} [parentOptionQuantity]
	 * @return {string}
	 */
	private getOptionTotalPrice(optionValue: Option, itemQuantity: number, parentOptionQuantity?: number): string {
		const { quantity, price } = optionValue;
		if (quantity && price) {
			return parentOptionQuantity ? (quantity * getEffectivePrice(optionValue) * itemQuantity * parentOptionQuantity).toFixed(2) : (quantity * getEffectivePrice(optionValue) * itemQuantity).toFixed(2);
		}
		else if (price) {
			return parentOptionQuantity ? (getEffectivePrice(optionValue) * itemQuantity * parentOptionQuantity).toFixed(2) : (getEffectivePrice(optionValue) * itemQuantity).toFixed(2);
		}
		return '';
	}
}
